import { useState } from "react"
import { useTranslation } from "react-i18next"
import ContactUs from "../../ContactUs/ContactUs"
import Button from "../../buttons/Button"

import styles from "./ContactBanner.module.scss"

// Ajusta la ruta según tu estructura

const ContactBanner = () => {
  const { t } = useTranslation()
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>
        {t("¿Quieres hablar con uno de nuestros expertos?")}
      </h2>
      <p className={styles.description}>{t("Ponte en contacto con nosotros")}</p>
      <div>
        <Button size="large" type="button" onClick={() => setModalOpen(true)} bordered={true}>
          {t("contacta")}
        </Button>
      </div>

        <ContactUs isOpen={modalOpen} onClose={() => setModalOpen(false)} />
   
    </div>
  )
}

export default ContactBanner
